export interface Vendor {
  vendorId: string;
  vendorName: string;
  vendorDisplayName: string;
  vendorLogoPath: string;
  availability: string;
  dealsBanner?: string;
  hasDeals: boolean;
  vendorLogo: string;
  template: string;
  vendorStorageLocation: string;
  // Legacy fields for backward compatibility
  id?: string;
  name?: string;
  displayName?: string;
}

export interface VendorResponse {
  vendors: Vendor[];
}

export interface PresignedUrlResponse {
  presignedUrl: string; // Our normalized property name
  // Note: The API returns 'preSignedUrl' (capital S), but we convert it in the API service
}

export interface ProductFeedPresignedUrlResponse {
  preSignedUrl: string;
  templatePreSignedUrl: string;
  fileName: string;
  vendor: string;
}

export enum UploadStatus {
  IDLE = 'IDLE',
  SELECTING = 'SELECTING',
  SELECTED = 'SELECTED',
  UPLOADING = 'UPLOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export interface UploadProgress {
  status: UploadStatus;
  progress: number;
  fileName: string;
  message?: string;
  error?: string;
}

export interface ImageConfig {
  vendorStorageLocation: 'hosted' | 'dropbox' | 'googleDrive';
  nestingaleLocation: string;
  imgNameSyntax: 'SKU_Index' | 'saveAsIs';
  dropBox?: {
    type: 'bySku' | 'shared';
    folderColumnName?: string;
    imagePattern?: 'skuname_*' | '*_skuname';
    sharedFolderURL?: string;
  };
}

export type VendorStorageLocationType = 'Hosted Images' | 'Dropbox' | 'Google Drive';
export interface ProductFeedAttributesPayload {
  vendor: string;
  nestingaleMap: Record<string, string | string[]>;
  imageConfig?: ImageConfig;
}
